import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
export default React.memo(function Switcher(props) {
    var _a, _b;
    const onChange = () => { var _a; return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, !props.checked); };
    const checkedClass = props.checked ? 'switcher-checked' : '';
    return (_jsxs(CheckBox, { className: `${props.className || ''} ui-switcher ${checkedClass}`, backgroundColor: (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : 'var(--accent-blue)', children: [_jsx("input", { name: props.name, type: "checkbox", checked: props.checked, onChange: onChange, disabled: (_b = props.disabled) !== null && _b !== void 0 ? _b : false }), _jsx("div", { children: _jsx("div", { children: props.icon }) })] }));
});
const CheckBox = styled.label `
  --padding: 0.312rem;
  --circle-size: 0.625rem;

  display: inline-block;

  cursor: pointer;

  & input {
    display: none;
  }

  & > div {
    position: relative;
    width: 1.75rem;
    height: var(--circle-size);
    padding: var(--padding);
    box-sizing: content-box;

    border-radius: 3.75rem;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid var(--ui-input-border-color);

    & > div {
      position: absolute;
      width: var(--circle-size);
      height: var(--circle-size);
      left: var(--padding);
      border-radius: 50%;
      transition: all 0.2s;
      background-color: white;

      svg {
        color: white;
      }
    }
  }

  & input:checked + div {
    background: ${props => props.backgroundColor};
    border: 1px solid var(--ui-input-border-color);
  }

  & input:checked + div > div {
    left: calc(100% - var(--padding));
    margin-left: calc(-1 * var(--circle-size));

    svg {
      color: ${props => props.backgroundColor};
    }
  }

  &:hover {
    & > div {
      border: 1px solid var(--ui-input-border-hover);
    }

    & > input:checked + div {
      background: linear-gradient(0deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.06)), #4093F4;
    }
  }
`;
